import { PRODUCER_CODE_HARDCODE } from "@/config/config";
import { BUSINESS_TYPE, LOB } from "@/config/constants";
import { createSlice, current } from "@reduxjs/toolkit";

const ERROR_INITIAL = {
  hasError: false,
  error: "",
};
const initialState = {
  productName: "ELDER_CARE",
  quoteNumber: "",
  members: [],
  membersDob: {},
  quoteDetails: { sumInsured: 500000, tenure: 1, deductible: 300000 },
  quoteAdditionalInfo: {
    pincode: "",
    city: "",
    state: "",
    sumInsured: "",
    tenure: "",
    planType: "",
    multiSI: {},
    deductible: 300000,
    multiDeductible: {},
    zone: "",
    originalZone: "", // Zone from initial pincode, used for upgrade zone logic
  },
  isClone: false,
  showBanca: false,
  preExistingIllness: [],
  immutablePreExistingIllness: [],
  payload: {
    lob: LOB.HEALTH,
    businessType: "New Business",
    prevPolicyEndDate: "",
    portability: false,
    tenure: 1,
    typeOfProduct: "Retail",
    isEmployee: false,
    goGreen: false,
    planType: "Floater",
    solId: "s123",
    source: "QUICK-QUOTE",
    producerCode: PRODUCER_CODE_HARDCODE,
    ipAddress: "1.2.3.4",
    isExistingCustomer: false,
    branchLocation: "MUMBAI",
    loginEmail: "",
    proposer: {
      address: {
        pincode: "110058",
      },
    },
    memberDetails: [
      {
        sumInsured: 500000,
        dob: "02/02/1953",
        relationship: "Self",
        deductible: 300000,
      },
      {
        sumInsured: 500000,
        dob: "08/08/1954",
        relationship: "Spouse",
        deductible: 300000,
      },
    ],
  },
  premiumDetails: {},
  selectedQuote: {},
  optionalBenefits: {},
  cloneSelectedAddOn: {},
  selectedAddOn: {},
  selectedPackage: {},
  error: ERROR_INITIAL,
  PDPerror: ERROR_INITIAL,
  applyNowPDP: false,
  // bancaDetails: {},
  bancaFields: {},
  businessType: BUSINESS_TYPE.NEW,
  prevBusinessType: BUSINESS_TYPE.NEW,
  portFileDetails: {},
  portData: [],
  portLoader: false,
  portabilityDocument: "",
  documentReferenceId: "",
  externalPOSP: false,
  selectedProducts: {},
  packages: {},
  cloneSelectedPackage: {},
  clonedProposalNumber: "",
  clonedProductCode: null,
  addOnsForPackages: {},
  rebookCancelPolicy: "",
  policyDetails: {},
  rebookPolicyNo: "",
  isRebookPolicyEditable: false,
  isEmployee: false,
  showExistingIllnessBlock: false,
  proposerGender: "male",
  discounts: {
    professionalDiscountOpted: false,
    employeeDiscountOpted: false,
    lieuOfCommissionOpted: false,
  },
  xtraSureOptions: [],
  isOrderTrackingConsentPending: false,
  superchargeRiderLoading: 0,
  receiptNumber: "",
  membersNationality: {},
  skipAutoReviseQuote: false,
  transicareFormData: {},
};

export const quoteSlice = createSlice({
  name: "quote",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setMemberData: (state, action) => {
      state.members = action.payload;
      let cloneObj = {};
      const membersDob = current(state.membersDob);
      cloneObj["pincode"] = membersDob.pincode;
      Object.keys(membersDob).forEach((member) => {
        state.members.forEach((mem) => {
          if (
            member.split("Dob")[0].toLowerCase() ===
            mem.relation.split(" ").join("").toLowerCase()
          ) {
            cloneObj[member] = membersDob[member];
          }
        });
      });
      state.membersDob = cloneObj;
    },
    setMemberDobData: (state, action) => {
      state.membersDob = action.payload;
    },
    setQuoteDetails: (state, action) => {
      state.quoteDetails = action.payload;
    },
    setQuotesData: (state, action) => {
      state.quote = action.payload;
      // Reset the error
      state.error = ERROR_INITIAL;
    },
    setQuoteError: (state, action) => {
      state.error = action.payload;
    },
    setPDPError: (state, action) => {
      state.PDPerror = action.payload;
    },
    setPayload: (state, action) => {
      state.payload = action.payload;
    },
    setQuoteNumber: (state, action) => {
      state.quoteNumber = action.payload;
    },
    clearQuoteData: () => {
      return initialState;
    },
    setQuoteAdditionalInfoData: (state, action) => {
      state.quoteAdditionalInfo = {
        ...state.quoteAdditionalInfo,
        ...action.payload,
      };
    },
    setIsClone: (state, action) => {
      state.isClone = action.payload;
    },
    setPremiumDetails: (state, action) => {
      state.premiumDetails = action.payload;
    },
    setSelectedQuote: (state, action) => {
      state.selectedQuote = action.payload;
    },
    setCloneSelectedAddOn: (state, action) => {
      state.cloneSelectedAddOn = action.payload;
    },
    setCloneSelectedPackage: (state, action) => {
      state.cloneSelectedPackage = action.payload;
    },
    setClonedProductCode: (state, action) => {
      state.clonedProductCode = action.payload;
    },
    setOptionalBenefits: (state, action) => {
      state.optionalBenefits = action.payload;
    },
    setSelectedAddOn: (state, action) => {
      state.selectedAddOn = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    clearSelectedQuoteData: (state, action = { payload: {} }) => {
      return { ...initialState.selectedQuote, ...action.payload };
    },
    setapplyNowPDP: (state, action) => {
      state.applyNowPDP = action.payload;
    },
    setShowBanca: (state, action) => {
      state.showBanca = action.payload;
    },
    setBancaFields: (state, action) => {
      state.bancaFields = action.payload;
    },
    // setBancaDetails: (state, action) => {
    //   state.bancaDetails = action.payload;
    // },
    setBusinessType: (state, action) => {
      state.businessType = action.payload;
    },
    setPrevBusinessType: (state, action) => {
      state.prevBusinessType = action.payload;
    },
    setPortFileDetails: (state, action) => {
      state.portFileDetails = action.payload;
    },
    setPortData: (state, action) => {
      state.portData = [...state.portData, action.payload];
    },
    clearPortData: (state, action) => {
      state.portData = [];
    },
    setPortLoader: (state, action) => {
      state.portLoader = action.payload;
    },
    setPortabilityDocument: (state, action) => {
      state.portabilityDocument = action.payload;
    },
    setDocumentReferenceId: (state, action) => {
      state.documentReferenceId = action.payload;
    },
    setPOSP: (state, action) => {
      state.externalPOSP = action.payload;
    },
    setSelectedProducts: (state, action) => {
      state.selectedProducts = action.payload;
    },
    setPackages: (state, action) => {
      state.packages = action.payload;
    },
    setClonedProposalNumber: (state, action) => {
      state.clonedProposalNumber = action.payload;
    },
    setPackageAddOns: (state, action) => {
      state.addOnsForPackages = action.payload;
    },
    setRebookCancelPolicy: (state, action) => {
      state.rebookCancelPolicy = action.payload;
    },
    setPolicyDetails: (state, action) => {
      state.policyDetails = action.payload;
    },
    setRebookPolicyNo: (state, action) => {
      state.rebookPolicyNo = action.payload;
    },
    setRebookPolicyEditable: (state, action) => {
      state.isRebookPolicyEditable = action.payload;
    },
    setIsEmployee: (state, action) => {
      state.isEmployee = action.payload;
    },
    setPreExistingIllness: (state, action) => {
      state.preExistingIllness = action.payload;
    },
    setShowExistingIllnessBlock: (state, action) => {
      state.showExistingIllnessBlock = action.payload;
    },
    setImmutablePreExistingIllness: (state, action) => {
      state.immutablePreExistingIllness = action.payload;
    },
    updateProposerGender: (state, action) => {
      state.proposerGender = action.payload;
    },
    updateDiscounts: (state, action) => {
      state.discounts = { ...state.discounts, ...action.payload };
    },
    updateXtraSureOptions: (state, action) => {
      state.xtraSureOptions = action.payload;
    },

    setIsOrderTrackingConsentPending: (state, action) => {
      state.isOrderTrackingConsentPending = action.payload;
    },
    setsuperchargeRiderLoading: (state, action) => {
      state.superchargeRiderLoading = action.payload;
    },
    setReceiptNumber: (state, action) => {
      state.receiptNumber = action.payload;
    },
    setMembersNationality: (state, action) => {
      state.membersNationality = action.payload;
    },
    setSkipAutoReviseQuote: (state, action) => {
      state.skipAutoReviseQuote = action.payload;
    },
    setTransicareFormData: (state, action) => {
      state.transicareFormData = action.payload;
    },
  },
});

export const {
  setMemberData,
  setQuotesData,
  setQuoteDetails,
  setMemberDobData,
  clearQuoteData,
  setPayload,
  setQuoteNumber,
  setQuoteError,
  setPDPError,
  setQuoteAdditionalInfoData,
  setIsClone,
  setPremiumDetails,
  setSelectedQuote,
  setOptionalBenefits,
  setSelectedAddOn,
  setCloneSelectedAddOn,
  setCloneSelectedPackage,
  setClonedProductCode,
  setSelectedPackage,
  clearSelectedQuoteData,
  setapplyNowPDP,
  setShowBanca,
  setBancaFields,
  setBusinessType,
  setPrevBusinessType,
  setPortFileDetails,
  setPortData,
  clearPortData,
  setPortLoader,
  setPortabilityDocument,
  setDocumentReferenceId,
  setPOSP,
  setSelectedProducts,
  setPackages,
  setClonedProposalNumber,
  setPackageAddOns,
  setRebookCancelPolicy,
  setPolicyDetails,
  // setBancaDetails,
  setRebookPolicyNo,
  setRebookPolicyEditable,
  setIsEmployee,
  setPreExistingIllness,
  setImmutablePreExistingIllness,
  setShowExistingIllnessBlock,
  updateProposerGender,
  updateDiscounts,
  updateXtraSureOptions,
  setIsOrderTrackingConsentPending,
  setsuperchargeRiderLoading,
  setReceiptNumber,
  setMembersNationality,
  setSkipAutoReviseQuote,
  setTransicareFormData,
} = quoteSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getMembers = (state) => state.quote?.members;
export const getExternalPOSP = (state) => state.quote.externalPOSP;
export const getMembersDob = (state) => state.quote?.membersDob;
export const getQuoteDetails = (state) => state.quote?.quoteDetails;
export const getPayload = (state) => state.quote?.payload;
export const getQuotesData = (state) => state.quote?.quote ?? [];
export const getQuoteError = (state) => state.quote?.error;
export const getPDPError = (state) => state.quote?.PDPerror;
export const getQuoteNumber = (state) => state.quote?.quoteNumber;
export const getQuoteAdditionalInfoData = (state) =>
  state.quote?.quoteAdditionalInfo;
export const getIsClone = (state) => state.quote.isClone;
export const getPremiumDetails = (state) => state.quote.premiumDetails;
export const getSelectedQuote = (state) => state.quote.selectedQuote;
export const getOptionalBenefits = (state) => state.quote.optionalBenefits;
export const getSelectedAddOn = (state) => state.quote.selectedAddOn;
export const getSelectedPackage = (state) => state.quote.selectedPackage;
export const getapplyNowPDP = (state) => state.quote.applyNowPDP;
export const getShowBanca = (state) => state.quote.showBanca;
export const getBancaFields = (state) => state.quote.bancaFields;
export const getBusinessType = (state) => state.quote.businessType;
export const getPrevBusinessType = (state) => state.quote.prevBusinessType;
export const getportFileDetails = (state) => state.quote.portFileDetails;
export const getPortData = (state) => state.quote.portData;
export const getPortLoader = (state) => state.quote.portLoader;
export const getPortabilityDocument = (state) =>
  state.quote.portabilityDocument;
// export const getBancaDetails = (state) => state.quote.bancaDetails;
export const getcloneSelectedAddOn = (state) => state.quote.cloneSelectedAddOn;
export const getcloneSelectedPackage = (state) =>
  state.quote.cloneSelectedPackage;
export const getDocumentReferenceId = (state) =>
  state.quote.documentReferenceId;
export const getSelectedProducts = (state) => state.quote.selectedProducts;
export const getClonedProposalNumber = (state) =>
  state.quote.clonedProposalNumber;
export const getClonedProductCode = (state) => state.quote.clonedProductCode;
export const getPackages = (state) => state.quote.packages;
export const getPackageAddOns = (state) => state.quote.addOnsForPackages;
export const getRebookCancelPolicy = (state) => state.quote.rebookCancelPolicy;
export const getPolicyDetails = (state) => state.quote.policyDetails;
export const getRebookPolicyNo = (state) => state.quote.rebookPolicyNo;
export const getIsRebookPolicyEditable = (state) =>
  state.quote.isRebookPolicyEditable;
export const getIsEmployee = (state) => state.quote.isEmployee;
export const getPreExistingIllness = (state) => state.quote.preExistingIllness;
export const getShowExistingIllnessBlock = (state) =>
  state.quote.showExistingIllnessBlock;
export const getImmutablePreExistingIllness = (state) =>
  state.quote.immutablePreExistingIllness;
export const getProposerGender = (state) => state.quote.proposerGender;
export const getDiscounts = (state) => state.quote.discounts;
export const getXtraSureOptions = (state) => state.quote.xtraSureOptions;
export const getIsOrderTrackingConsentPending = (state) =>
  state.quote.isOrderTrackingConsentPending;
export const getsuperchargeRiderLoading = (state) =>
  state.quote.superchargeRiderLoading;
export const getReceiptNumber = (state) => state.quote.receiptNumber;
export const getMembersNationality = (state) => state.quote.membersNationality;
export const getSkipAutoReviseQuote = (state) =>
  state.quote.skipAutoReviseQuote;
export const getTransicareFormData = (state) => state.quote.transicareFormData;

export default quoteSlice.reducer;
